export interface PricingTier {
  volumen: number
  precio: number
}

export const TIERS_CORREO: PricingTier[] = [
  { volumen: 1000, precio: 0.50 },
  { volumen: 2000, precio: 0.37 },
  { volumen: 3000, precio: 0.31 },
  { volumen: 5000, precio: 0.25 },
  { volumen: 7500, precio: 0.22 },
  { volumen: 10000, precio: 0.19 },
  { volumen: 15000, precio: 0.16 },
  { volumen: 20000, precio: 0.14 },
  { volumen: 30000, precio: 0.12 },
  { volumen: 50000, precio: 0.10 },
]

export const TIERS_WHATSAPP: PricingTier[] = [
  { volumen: 1000, precio: 0.52 },
  { volumen: 2000, precio: 0.40 },
  { volumen: 3000, precio: 0.34 },
  { volumen: 5000, precio: 0.28 },
  { volumen: 7500, precio: 0.25 },
  { volumen: 10000, precio: 0.22 },
  { volumen: 15000, precio: 0.18 },
  { volumen: 20000, precio: 0.16 },
  { volumen: 30000, precio: 0.14 },
  { volumen: 50000, precio: 0.12 },
]

export const TIERS_CORREO_WHATSAPP: PricingTier[] = [
  { volumen: 1000, precio: 0.78 },
  { volumen: 2000, precio: 0.61 },
  { volumen: 3000, precio: 0.52 },
  { volumen: 5000, precio: 0.43 },
  { volumen: 7500, precio: 0.38 },
  { volumen: 10000, precio: 0.34 },
  { volumen: 15000, precio: 0.30 },
  { volumen: 20000, precio: 0.27 },
  { volumen: 30000, precio: 0.24 },
  { volumen: 50000, precio: 0.20 },
]

// Volúmenes disponibles incluyendo 0 (sin servicio)
export const TIER_VOLUMES = [0, 1000, 2000, 3000, 5000, 7500, 10000, 15000, 20000, 30000, 50000]

export function obtenerPrecioUnitario(volumen: number, tiers: PricingTier[]): number {
  if (volumen <= 0) return 0
  volumen = Math.max(volumen, 1000)
  let precio = tiers[0].precio
  for (const tier of tiers) {
    if (volumen >= tier.volumen) {
      precio = tier.precio
    }
  }
  return precio
}

export function calcularPrecioMensual(
  volCorreo: number,
  volWhatsapp: number,
  volCorreoWhatsapp: number
): number {
  let precio = 0
  if (volCorreo > 0) precio += volCorreo * obtenerPrecioUnitario(volCorreo, TIERS_CORREO)
  if (volWhatsapp > 0) precio += volWhatsapp * obtenerPrecioUnitario(volWhatsapp, TIERS_WHATSAPP)
  if (volCorreoWhatsapp > 0) precio += volCorreoWhatsapp * obtenerPrecioUnitario(volCorreoWhatsapp, TIERS_CORREO_WHATSAPP)
  return Math.round(precio * 100) / 100
}

export function formatearNumero(n: number): string {
  return n.toLocaleString('es-EC')
}

export function formatearPrecio(n: number): string {
  return `$${n.toLocaleString('es-EC', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export type ServicioKey = 'correo' | 'whatsapp' | 'correo_whatsapp'

export const SERVICIOS: { key: ServicioKey; label: string; tiers: PricingTier[] }[] = [
  { key: 'correo', label: 'Correo', tiers: TIERS_CORREO },
  { key: 'whatsapp', label: 'WhatsApp', tiers: TIERS_WHATSAPP },
  { key: 'correo_whatsapp', label: 'Correo + WhatsApp', tiers: TIERS_CORREO_WHATSAPP },
]
